import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Page from 'components/pages/Base/Page/Page';

const StyledCollectionEntitiesGraphsPage = styled(Page)`
  padding: ${props => props.theme.spacing(3)};
  background-color: ${props => props.theme.property('palette.primary.states.hover')};
  
  .CollectionEntitiesGraphsPage {
    &-dealflowBreakdown {
      aspect-ratio: 536/470;
    }
    &-completeness {
      aspect-ratio: 758/470;
      min-height: ${props => props.theme.layout(360)};
    }
    &-recentChanges {
      aspect-ratio: 816/470;
      min-height: ${props => props.theme.layout(360)};
    }
    &-latestNews {
      min-height: ${props => props.theme.layout(360)};
    }
    &-relevancyDistribution {
      min-height: ${props => props.theme.layout(360)};
    }
    &-tagDistribution {
      aspect-ratio: 480/480;
    }
    &-news-wrapper {
      display: flex;
      flex-direction: column;
      gap: ${props => props.theme.layout('3sp')};

      > *:not(:first-child) {
        flex-grow: 1;
      }
    }
    &-tasks-wrapper {
      display: flex;
      flex-direction: column;
      gap: ${props => props.theme.layout('3sp')};
      
      > *:not(:first-child) {
        flex-grow: 1;
      }
    }
    &-tasks {
      height: ${props => props.theme.layout(226)};
    }
    &-openTasks {
      min-height: ${props => props.theme.layout(440)};
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    padding: ${props => props.theme.spacing(2)};
    
    .CollectionEntitiesGraphsPage {
      &-tasks-wrapper {
        gap: ${props => props.theme.layout('2sp')};
      }
      &-news-wrapper {
        gap: ${props => props.theme.layout('2sp')};
      }
      &-dealflowBreakdown {
        max-height: ${props => props.theme.layout(444)};
      }
      &-tagDistribution {
        max-height: ${props => props.theme.layout(544)};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledCollectionEntitiesGraphsPage.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionEntitiesGraphsPage;
